var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 2h10M15.076 8.667V2H8.924v6.667L3.398 17.88a2.824 2.824 0 0 0-.396 1.347c-.018.48.084.955.295 1.377.211.421.523.774.903 1.02.38.245.815.375 1.257.376H18.54c.443 0 .878-.13 1.259-.375.38-.246.693-.598.904-1.02a2.85 2.85 0 0 0 .296-1.377 2.825 2.825 0 0 0-.396-1.348l-5.526-9.213zM7 13h10M14.226 17.25h3M15.726 15.75v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.726 19.125a.375.375 0 0 1 .374.375M6.351 19.5a.375.375 0 0 1 .375-.375M6.726 19.875a.375.375 0 0 1-.375-.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.1 19.5a.375.375 0 0 1-.375.375M9.726 16.125a.375.375 0 0 1 .375.375M9.351 16.5a.375.375 0 0 1 .375-.375M9.726 16.875a.375.375 0 0 1-.375-.375"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.1 16.5a.375.375 0 0 1-.375.375M15 5.5h-2M15 8h-2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction);
export default __webpack_public_path__ + "static/media/reaction.0ffb046b.svg";
export { ForwardRef as ReactComponent };